// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__169JC","title":"card_title__1buaV","inActive":"card_inActive__22tS2"};